import IconSvg from './svg/icon-svg'

export const Icon = ({ name, ...rest }: any) => {
  switch (name) {
    case 'menu': return <IconSvg name="menu" {...rest} />
    case 'camera-menu': return <IconSvg name="camera-menu" {...rest} />
    case 'camera-disabled-menu': return <IconSvg name="camera-disabled-menu" {...rest} />
    case 'gallery-menu': return <IconSvg name="gallery-menu" {...rest} />
    case 'restart-menu': return <IconSvg name="restart-menu" {...rest} />
    case 'files-menu': return <IconSvg name="files-menu" {...rest} />
    case 'microphone': return <IconSvg name="microphone" {...rest} />
    case 'check-input': return <IconSvg name="check-input" {...rest} />
    case 'close': return <IconSvg name="close" {...rest} />
    case 'home': return <IconSvg name="home" {...rest} />
    case 'logo': return <IconSvg name="logo" {...rest} />
    case 'config': return <IconSvg name="config" {...rest} />
    case 'audio': return <IconSvg name="audio" {...rest} />
    case 'mute': return <IconSvg name="mute" {...rest} />
    case 'arrow-right': return <IconSvg name="arrow-right" {...rest} />
    case 'arrow-connection-line': return <IconSvg name="arrow-connection-line" {...rest} />
    case 'check': return <IconSvg name="check" {...rest} />
    case 'x': return <IconSvg name="x" {...rest} />
    case 'next': return <IconSvg name="next" {...rest} />
    case 'previous': return <IconSvg name="previous" {...rest} />
    case 'team': return <IconSvg name="team" {...rest} />
    case 'blocked': return <IconSvg name="blocked" {...rest} />
    case 'gift': return <IconSvg name="gift" {...rest} />
    case 'diamond': return <IconSvg name="diamond" {...rest} />
    case 'done-point': return <IconSvg name="done-point" {...rest} />
    case 'current-point': return <IconSvg name="current-point" {...rest} />
    case 'done-group-point': return <IconSvg name="done-group-point" {...rest} />
    case 'zoom': return <IconSvg name="zoom" {...rest} />
    case 'pencil': return <IconSvg name="pencil" {...rest} />
    case 'check-icon': return <IconSvg name="check-icon" {...rest} />
    case 'google-icon': return <IconSvg name="google-icon" {...rest} />
    default: return null
  }
}
